import React, { Component } from "react";
import { Table } from "reactstrap";
import MPSButton from "../../../components/Buttons/Buttons/MPSButton";

class SurveySelect extends Component {
  render() {
    let { surveys, surveyId, surveyName, noCreate } = this.props;

    const selectedItem = surveys.find(
      (item) =>
        item.id === surveyId ||
        item.name === surveyName ||
        (item.idFromPackage && item.idFromPackage === surveyId)
    );

    return (
      <div className="row">
        <div className="col-12 col-sm-12">
          {selectedItem && (
            <div style={{
              padding: '8px 12px',
              marginBottom: 12,
              background: 'rgba(6, 190, 182, 0.1)',
              borderLeft: '3px solid rgb(6, 190, 182)',
              borderRadius: 4,
              fontSize: '0.875rem',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
            title={selectedItem.name + ": " + selectedItem.description}
            >
              <strong>Currently selected:</strong>{' '}
              {selectedItem.name}: {selectedItem.description}
            </div>
          )}

          <Table responsive style={{ marginBottom: noCreate ? 300 : 60 }}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              {surveys.map((item, index) => {
                const isSelected =
                  item.id === surveyId ||
                  item.name === surveyName ||
                  (item.idFromPackage && item.idFromPackage === surveyId);

                return (
                  <tr
                    key={index}
                    className="attribute-row-hover"
                    style={{
                      cursor: "pointer",
                      ...(isSelected ? { background: "rgba(6, 190, 182, 0.2)" } : {}),
                    }}
                    onClick={() => {
                      this.props.save(item.id, item.title, item.name);
                    }}
                  >
                    <td>{item.name}</td>
                    <td>{item.description}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>

          {!noCreate && (
            <div style={{
              position: 'sticky',
              bottom: 0,
              background: '#f8f9fa',
              borderTop: '1px solid #dee2e6',
              padding: '10px 16px',
              textAlign: 'center',
              fontSize: '0.875rem',
            }}>
              Need something new?{' '}
              <MPSButton type="link" onClick={this.props.showCreateSurvey}>
                Create a Survey
              </MPSButton>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default SurveySelect;
